import {Dispatch, FC, SetStateAction} from 'react';

import {DialogContent, Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

import {CloseIcon} from 'assets/icons/closeIcon';
import {BasketProductImage} from 'components/basket-product-image/BasketProductImage';
import {ProductType} from 'types';
import {formatPrice, getCurrencySymbol} from 'utils/currency';
import DiscountPriceBox from 'views/discount-price-box/DiscountPriceBox';

import {
  ModalContent,
  StyledCardContentWrapper,
  StyledDialogTitle,
  StyledCardContent,
  StyledModal,
  StyledTitleTypography,
  StyledContetTypography,
  StyledPriceContainer,
  StyledPriceTypography,
  StyledUpTitleTypography,
  StyledIconButton
} from './styles';

interface weightedFreshPopupProps {
  showWeightedFreshModal: boolean;
  setShowWeightedFreshModal: Dispatch<SetStateAction<boolean>>;
  coverImageURL: string;
  title: string;
  weight: string;
  priceUnit: string;
  productType: ProductType;
  originPrice: number;
  displayPrice: number;
  promotedPrice?: number;
  upchargePercentage?: number;
}

export const WeightedFreshPopup: FC<weightedFreshPopupProps> = ({
  showWeightedFreshModal,
  setShowWeightedFreshModal,
  title,
  coverImageURL,
  priceUnit,
  originPrice,
  displayPrice,
  weight,
  promotedPrice,
  productType,
  upchargePercentage
}: weightedFreshPopupProps) => {
  return (
    <>
      <StyledModal open={showWeightedFreshModal} onClose={() => setShowWeightedFreshModal(!showWeightedFreshModal)}>
        <StyledDialogTitle>
          <StyledUpTitleTypography>{t('weightedFresh.processingFee')}</StyledUpTitleTypography>
          <StyledIconButton aria-label="close" onClick={() => setShowWeightedFreshModal(false)}>
            <CloseIcon />
          </StyledIconButton>
        </StyledDialogTitle>
        <DialogContent>
          <ModalContent>
            <StyledCardContentWrapper role="button" tabIndex={0} onKeyDown={() => null}>
              <BasketProductImage src={coverImageURL} productType={productType} />
              <StyledCardContent>
                <StyledTitleTypography color="secondary" gutterBottom variant="body1" component="p">
                  <b>{title}</b>
                </StyledTitleTypography>
                <Typography display={'block'} variant="caption" color="text.secondary">
                  {weight}
                </Typography>
                <DiscountPriceBox
                  originPrice={originPrice}
                  priceUnit={priceUnit}
                  displayPrice={promotedPrice ? promotedPrice : displayPrice}
                />
              </StyledCardContent>
            </StyledCardContentWrapper>
          </ModalContent>
          <StyledContetTypography>
            <Trans
              i18nKey={t('weightedFresh.message', {
                percentage: upchargePercentage
              })}
              components={{
                b: <b />,
                span: <span />
              }}
            />
            <StyledPriceContainer>
              <Box display="flex">
                {t('upcharge.regularPrice')}:
                <StyledPriceTypography>
                  {formatPrice(originPrice)} {getCurrencySymbol()}
                </StyledPriceTypography>
              </Box>
              <Box display="flex">
                {t('weightedFresh.priceAfterProcessing')}:
                <StyledPriceTypography>
                  {formatPrice(promotedPrice)} {getCurrencySymbol()}
                </StyledPriceTypography>{' '}
              </Box>
            </StyledPriceContainer>
          </StyledContetTypography>
        </DialogContent>
      </StyledModal>
    </>
  );
};
